import restClient from "../restClient";

export const getCustomerDeposits = async (customerId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        customer: customerId,
      },
    };
    const response = await restClient.get(`customer-deposits`, config);
    return response.data;
  } catch (err) {
    console.log('Error fetching customer deposits:', err);
    throw err;
  }
};

export const createCustomerDeposit = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`customer-deposits`, { data }, config);
    return response.data;
  } catch (err) {
    console.log('Error creating customer deposit:', err);
    throw err;
  }
};

export const updateCustomerDeposit = async (tranId, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`customer-deposits/${tranId}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log('Error updating customer deposit:', err);
    throw err;
  }
};

